module.exports = __webpack_public_path__ + "static/media/apartment12.f7f4d54a.png";